import { PublicClientApplication } from '@azure/msal-browser';
import type {
  AccountInfo,
  IPublicClientApplication,
} from '@azure/msal-browser';

import { config } from '../config.js';

import { getMainPca } from './mainPca.js';
import { msalConfig } from './msalConfig.js';

let datalakePca: PublicClientApplication | null = null;

// Both tenants' sign-ins share one MSAL home account, and each token save
// overwrites the other tenant's cached profile. A separate cache keeps them apart.
export function getDatalakePca(): PublicClientApplication {
  if (config.datalakeTenantId === config.entraTenantId) return getMainPca();
  datalakePca ??= new PublicClientApplication({
    ...msalConfig,
    auth: {
      ...msalConfig.auth,
      authority: `https://login.microsoftonline.com/${config.datalakeTenantId}`,
    },
    cache: { cacheLocation: 'sessionStorage' },
  });
  return datalakePca;
}

// DataLake authorizes the corporate-tenant identity, not the app's sign-in tenant.
export function getDatalakeAccount(
  pca: IPublicClientApplication,
): AccountInfo | null {
  return (
    pca
      .getAllAccounts()
      .find((account) => account.tenantId === config.datalakeTenantId) ?? null
  );
}
